// function backToTop() {
//     let offset = 300,
//         offset_opacity = 1200,
//         scroll_top_duration = 700,
//         $back_to_top = $('.cd-top');
//     $(window).scroll(function() {
//         ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible'): $back_to_top.removeClass('cd-is-visible cd-fade-out');
//         // if ($(this).scrollTop() > offset_opacity) {
//         //     $back_to_top.addClass('cd-fade-out');
//         // }
//     });
//     $back_to_top.on('click', (event) => {
//         event.preventDefault();
//         $('body,html').animate({ scrollTop: 0, }, scroll_top_duration);
//     });

// }

// backToTop();

$(document).ready(function () {
        // console.log($('#back-to-top').length)
    if ($('#back-to-top').length) {
        // console.log('asd')
        // $("html, body").animate({ scrollTop: $('#app').offset().top }, 1000);
        var scrollTrigger = $('#app').offset().top + 500, // px
            backToTop = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    $('#back-to-top').addClass('show');
                } else {
                    $('#back-to-top').removeClass('show');
                }
            };
        backToTop();
        $(window).on('scroll', function () {
            backToTop();
        });
        $('#back-to-top').on('click', function (e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: $('html').offset().top
            }, 1000);
        });
    }else {
        console.log('aa')
    }

    });